import LiveClock from 'components/common/LiveClock'
import AddGroup from 'components/permissionGroup/AddGroup';
import React from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { PermissionSelector } from 'slices/permissionGroupSlice';

const CreateGroup = () => {
    const navigate = useNavigate();
    const { permissionList, loader, error } = useSelector(PermissionSelector);

    return (
        <div className='content'>
            <div className="row_main_head">
                <div className='d-flex align-items-center gap-2'>
                    <button className="main_heading back_button" onClick={() => navigate(-1)}>
                        <i className="fa-solid fa-arrow-left"></i> Back
                    </button>
                    <h2 className={`main_heading`}>Create Permission Group</h2>
                </div>
                {/* <LiveClock /> */}
            </div>

            <AddGroup loader={loader}/>
        </div>
    )
}

export default CreateGroup
